import { api } from "../../../services/api";
import { PORTFOLIOS_CREATE_ACTIONS, PORTFOLIOS_LIST_ACTIONS, POSITION_UNIT_VALUE, PORTFOLIOS_DELETE_ACTIONS, PORTFOLIOS_POSITION_LIST_ACTIONS, POSITION_DELETE_ACTIONS, POSITION_EDIT_GET_ACTIONS, PORTFOLIOS_POSITION_PRICEBYDATE_ACTIONS, PORTFOLIOSLIST_POSITION_ACTIONS, PORTFOLIO_POSITION_UPDATE_ACTIONS, PORTFOLIOS_POSITION_ACTIONS, PORTFOLIO_ADD_BYPOSITION } from "../../actionType/portfolios";
import { portfolios } from "../../../services/apiVariables";
import { Toast } from '../../../services/toast'
import { PORTFOLIOS_EXCEL_LIST_ACTIONS } from "../../actionType/portfolios";


export const createPortfolios =
  (body: any) => (dispatch: (arg0: { type: string; payload: any }) => void) => {
    dispatch({
      type: PORTFOLIOS_CREATE_ACTIONS.PORTFOLIOS_REQUEST,
      payload: { isPortfoliosCreatLoader: true },
    });
    return new Promise((resolve, reject) => {
      api({ ...portfolios.post, body })
        .then((data: any) => {
          dispatch({ type: PORTFOLIOS_CREATE_ACTIONS.PORTFOLIOS_RESPONSE, payload: data });
          resolve(data);
          if (data.code === 200) {
            Toast({ type: 'success', message: 'Portfolios created successfully', title: 'success' });
          } else {
            Toast({ type: 'danger', message: data.message, title: data.status });
          }
        })
        .catch((error) => {
          console.log("data portfolio", error);
          Toast({ type: 'danger', message: error, title: error.status });
          dispatch({ type: PORTFOLIOS_CREATE_ACTIONS.PORTFOLIOS_ERROR, payload: [] });
          reject(error);
        });
    });
  };


export const getPortfolios =
  (body: any) => (dispatch: (arg0: { type: string; payload: any }) => void) => {
    dispatch({
      type: PORTFOLIOS_LIST_ACTIONS.PORTFOLIOS_LIST_REQUEST,
      payload: { isPortfoliosCreatLoader: true },
    });
    return new Promise((resolve, reject) => {
      api({ ...portfolios.get, body })
        .then((data: any) => {
          dispatch({ type: PORTFOLIOS_LIST_ACTIONS.PORTFOLIOS_LIST_RESPONSE, payload: data });
          resolve(data);
        })
        .catch((error) => {
          Toast({ type: 'danger', message: error.message, title: error.status });
          dispatch({ type: PORTFOLIOS_LIST_ACTIONS.PORTFOLIOS_LIST_ERROR, payload: [] });
          reject(error);
        });
    });
  };

export const getPortfoliosExcel =
  (body: any) => (dispatch: (arg0: { type: string; payload: any }) => void) => {
    dispatch({
      type: PORTFOLIOS_EXCEL_LIST_ACTIONS.PORTFOLIOS_EXCEL_LIST_REQUEST,
      payload: { isPortfoliosCreatLoader: true },
    });
    return new Promise((resolve, reject) => {
      api({ ...portfolios.getExcel, body })
        .then((data: any) => {
          dispatch({ type: PORTFOLIOS_EXCEL_LIST_ACTIONS.PORTFOLIOS_EXCEL_LIST_RESPONSE, payload: data });
          resolve(data);
        })
        .catch((error) => {
          Toast({ type: 'danger', message: error.message, title: error.status });
          dispatch({ type: PORTFOLIOS_EXCEL_LIST_ACTIONS.PORTFOLIOS_EXCEL_LIST_ERROR, payload: [] });
          reject(error);
        });
    });
  };

export const getPosition =
  (body: any) => (dispatch: (arg0: { type: string; payload: any }) => void) => {
    dispatch({
      type: PORTFOLIOS_POSITION_ACTIONS.PORTFOLIOS_POSITION_REQUEST,
      payload: { isPortfoliosCreatLoader: true },
    });
    return new Promise((resolve, reject) => {
      api({ ...portfolios.getPosition, body })
        .then((data: any) => {
          dispatch({ type: PORTFOLIOS_POSITION_ACTIONS.PORTFOLIOS_POSITION_RESPONSE, payload: data });
          resolve(data);
        })
        .catch((error) => {
          // Toast({ type: 'danger', message: error.message, title: error.status });
          dispatch({ type: PORTFOLIOS_POSITION_ACTIONS.PORTFOLIOS_POSITION_ERROR, payload: [] });
          reject(error);
        });
    });
  };

export const updatePortfolios =
  (body: any) => (dispatch: (arg0: { type: string; payload: any }) => void) => {
    dispatch({
      type: PORTFOLIOS_CREATE_ACTIONS.PORTFOLIOS_REQUEST,
      payload: { isPortfoliosCreatLoader: true },
    });
    return new Promise((resolve, reject) => {
      let prefixUrl = `?portfolio_id=${body?.portfolio_id}`
      api({ ...portfolios.put, body, prefixUrl })
        .then((data: any) => {
          Toast({ type: 'success', message: 'Portfolios update successfully', title: 'success' });
          dispatch({ type: PORTFOLIOS_CREATE_ACTIONS.PORTFOLIOS_RESPONSE, payload: data });
          resolve(data);
        })
        .catch((error) => {
          Toast({ type: 'danger', message: error.message, title: error.status });
          dispatch({ type: PORTFOLIOS_CREATE_ACTIONS.PORTFOLIOS_RESPONSE, payload: [] });
          reject(error);
        });
    });
  };


export const deletePortfolios =
  (body: any) => (dispatch: (arg0: { type: string; payload: any }) => void) => {
    dispatch({
      type: PORTFOLIOS_DELETE_ACTIONS.PORTFOLIOS_DELETE_REQUEST,
      payload: { portfoliosDeleteLoader: true },
    });
    return new Promise((resolve, reject) => {
      api({ ...portfolios.delete, body })
        .then((data: any) => {
          // Toast({ type: 'success', message: 'Portfolios deleted successfully', title: 'success' });
          dispatch({ type: PORTFOLIOS_DELETE_ACTIONS.PORTFOLIOS_DELETE_REQUEST, payload: data[0] });
          if (data?.code === 200) {
            Toast({
              type: "success",
              message: "Portfolios deleted successfully",
              title: data.status,
              // loading: true,
            });
            resolve(data);
          } else {
            Toast({
              type: "error",
              message: data.message,
              title: data.status,
            });
            reject(data?.data);
          }
        })
        .catch((error) => {
          Toast({ type: 'danger', message: error.message, title: error.status });
          dispatch({ type: PORTFOLIOS_DELETE_ACTIONS.PORTFOLIOS_DELETE_REQUEST, payload: [] });
          reject(error);
        });
    });
  };
export const deletePortfoliosPosition =
  (body: any) => (dispatch: (arg0: { type: string; payload: any }) => void) => {
    dispatch({
      type: POSITION_DELETE_ACTIONS.POSITION_DELETE_REQUEST,
      payload: { portfoliosDeleteLoader: true },
    });
    return new Promise((resolve, reject) => {
      api({ ...portfolios.deletePosition, body })
        .then((data: any) => {
          Toast({ type: 'success', message: 'Position deleted successfully', title: 'success' });
          dispatch({ type: POSITION_DELETE_ACTIONS.POSITION_DELETE_REQUEST, payload: data });
          resolve(data);
        })
        .catch((error) => {
          Toast({ type: 'danger', message: error.message, title: error.status });
          dispatch({ type: POSITION_DELETE_ACTIONS.POSITION_DELETE_ERROR, payload: [] });
          reject(error);
        });
    });
  };




export const getEditPosition =
  (body: any) => (dispatch: (arg0: { type: string; payload: any }) => void) => {
    dispatch({
      type: POSITION_EDIT_GET_ACTIONS.POSITION_EDIT_GET_REQUEST,
      payload: { isPortfoliosCreatLoader: true },
    });
    return new Promise((resolve, reject) => {
      api({ ...portfolios.getPositionDetail, body })
        .then((data: any) => {
          dispatch({ type: POSITION_EDIT_GET_ACTIONS.POSITION_EDIT_GET_RESPONSE, payload: data });
          resolve(data);
        })
        .catch((error) => {
          Toast({ type: 'danger', message: 'Internal Server Error', title: 'Error' });
          dispatch({ type: POSITION_EDIT_GET_ACTIONS.POSITION_EDIT_GET_ERROR, payload: [] });
          reject(error);
        });
    });
  };

export const getPortfoliosPostion =
  (body: any) => (dispatch: (arg0: { type: string; payload: any }) => void) => {
    dispatch({
      type: PORTFOLIOS_POSITION_LIST_ACTIONS.PORTFOLIOS_POSITION_LIST_REQUEST,
      payload: { isPortfoliosCreatLoader: true },
    });
    return new Promise((resolve, reject) => {
      api({ ...portfolios.getView, body })
        .then((data: any) => {
          dispatch({ type: PORTFOLIOS_POSITION_LIST_ACTIONS.PORTFOLIOS_POSITION_LIST_RESPONSE, payload: data });
          if (data?.code === 200) {
            // Toast({
            //   type: "success",
            //   // message: data?.message,
            //   title: "success",
            //   loading: true,
            // });
            resolve(data);
          }
          else {
            // Toast({
            //   type: "error",
            //   message: data.message,
            //   title: data.status,
            // });
            reject(data?.data);
          }
        })
        .catch((error) => {
          Toast({ type: 'danger', message: 'Internal Server Error', title: 'Error' });
          dispatch({ type: PORTFOLIOS_POSITION_LIST_ACTIONS.PORTFOLIOS_POSITION_LIST_ERROR, payload: [] });
          reject(error);
        });
    });
  };

export const getPortfoliosPriceByDatePostion =
  (body: any) => (dispatch: (arg0: { type: string; payload: any }) => void) => {
    dispatch({
      type: PORTFOLIOS_POSITION_PRICEBYDATE_ACTIONS.PORTFOLIOS_POSITION_PRICEBYDATE_REQUEST,
      payload: { isportfolioPriceByDatePositionList: true },
    });
    return new Promise((resolve, reject) => {
      api({ ...portfolios.getView, body })
        .then((data: any) => {
          dispatch({ type: PORTFOLIOS_POSITION_PRICEBYDATE_ACTIONS.PORTFOLIOS_POSITION_PRICEBYDATE_RESPONSE, payload: data });
          resolve(data);
        })
        .catch((error) => {
          Toast({ type: 'danger', message: 'Internal Server Error', title: 'Error' });
          dispatch({ type: PORTFOLIOS_POSITION_PRICEBYDATE_ACTIONS.PORTFOLIOS_POSITION_PRICEBYDATE_ERROR, payload: [] });
          reject(error);
        });
    });
  };
export const getPortfoliosListPostion =
  (body: any) => (dispatch: (arg0: { type: string; payload: any }) => void) => {
    dispatch({
      type: PORTFOLIOSLIST_POSITION_ACTIONS.PORTFOLIOSLIST_POSITION_REQUEST,
      payload: { isPositionportfolioList: true },
    });
    return new Promise((resolve, reject) => {
      api({ ...portfolios.getPotfolioList, body })
        .then((data: any) => {
          dispatch({ type: PORTFOLIOSLIST_POSITION_ACTIONS.PORTFOLIOSLIST_POSITION_RESPONSE, payload: data });
          resolve(data);
        })
        .catch((error) => {
          Toast({ type: 'danger', message: 'Internal Server Error', title: 'Error' });
          dispatch({ type: PORTFOLIOSLIST_POSITION_ACTIONS.PORTFOLIOSLIST_POSITION_ERROR, payload: [] });
          reject(error);
        });
    });
  };
export const getPortfoliosPostionUpdate =
  (body: any) => (dispatch: (arg0: { type: string; payload: any }) => void) => {
    dispatch({
      type: PORTFOLIO_POSITION_UPDATE_ACTIONS.PORTFOLIO_POSITION_UPDATE_REQUEST,
      payload: { isPositionportfolioList: true },
    });
    return new Promise((resolve, reject) => {
      let prefixUrl = `?portfolio_detail_id=${body?.portfolio_detail_id}`
      api({ ...portfolios.getPotfolioUpdate, body, prefixUrl })
        .then((data: any) => {
          if (data?.code === 200) {
            Toast({ type: 'success', message: 'Position updated successfully', title: 'Error' });
          }

          dispatch({ type: PORTFOLIO_POSITION_UPDATE_ACTIONS.PORTFOLIO_POSITION_UPDATE_RESPONSE, payload: data });
          resolve(data);
        })
        .catch((error) => {
          Toast({ type: 'danger', message: 'Internal Server Error', title: 'Error' });
          dispatch({ type: PORTFOLIO_POSITION_UPDATE_ACTIONS.PORTFOLIO_POSITION_UPDATE_ERROR, payload: [] });
          reject(error);
        });
    });
  };


export const addPortfolioByPosition = (trigger: any) => (dispatch: (arg0: { type: string; payload: any }) => void) => {
  console.log("trigger", trigger);

  dispatch({ type: PORTFOLIO_ADD_BYPOSITION.PORTFOLIO_ADD_BYPOSITION_REQUEST, payload: trigger });
  return new Promise((resolve, reject) => {
    // Toast({ type: 'success', message: 'User Detail update successfully', title: 'success' });
    dispatch({ type: PORTFOLIO_ADD_BYPOSITION.PORTFOLIO_ADD_BYPOSITION_RESPONSE, payload: trigger });
    resolve(trigger)
  });
}
export const PositionUnitValue = (unitValue: any) => (dispatch: (arg0: { type: string; payload: any }) => void) => {
  console.log("trigger", unitValue);

  dispatch({ type: POSITION_UNIT_VALUE.POSITION_UNIT_VALUE, payload: unitValue });
  return new Promise((resolve, reject) => {
    // Toast({ type: 'success', message: 'User Detail update successfully', title: 'success' });
    dispatch({ type: POSITION_UNIT_VALUE.POSITION_UNIT_VALUE, payload: unitValue });
    resolve(unitValue)
  });
}